const appEventData = (window.appEventData = window.appEventData || []);
export default appEventData;
